import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import api from '@/services/api';
import { GetProductsPaginated } from '@/store/Product/types';

const PER_PAGE = 20;

const KEY_PRODUCT_NAME_SEARCH = 'KEY_PRODUCT_NAME_SEARCH';

export const useProductNameSearch = (name: string | undefined) => {
    const query = useInfiniteQuery({
        queryKey: [KEY_PRODUCT_NAME_SEARCH, name],
        queryFn: async ({ pageParam = 1 }) => {
            const response = await api.get<GetProductsPaginated>('/product', {
                params: { name, page: pageParam, perPage: PER_PAGE },
            });
            return response.data;
        },
        getNextPageParam: (lastPage) =>
            lastPage.meta.next_page_url
                ? lastPage.meta.current_page + 1
                : undefined,
        enabled: !!name,
        refetchOnWindowFocus: false,
    });

    const products = useMemo(
        () => query.data?.pages.flatMap((page) => page.data) ?? [],
        [query.data],
    );

    return {
        products,
        isLoading: query.isLoading,
        isSuccess: query.isSuccess,
        isError: query.isError,
        isFetching: query.isFetching,
        hasNextPage: query.hasNextPage,
        fetchNextPage: query.fetchNextPage,
    };
};
